// ============================================================
// MOCK DATA - Única fuente de verdad temporal (fase frontend)
// Será reemplazada por API backend (MongoDB) en la fase 2
// Persistencia temporal: localStorage
// ============================================================

const LS_KEYS = {
  products: 'natur_products',
  cities: 'natur_cities',
  valueLists: 'natur_value_lists',
  franchises: 'natur_franchises',
  orders: 'natur_orders',
  cart: 'natur_cart',
};

// ---------- FRANQUICIAS ----------
export const seedFranchises = [
  { id: 'matriz', name: 'MATRIZ - Natur Autoescuela', type: 'matriz', city: 'Madrid', active: true },
  { id: 'fr-valdemoro', name: 'Natur Autoescuela Valdemoro', type: 'franquicia', city: 'Valdemoro', active: true },
  { id: 'fr-alcorcon', name: 'Natur Autoescuela Alcorcón', type: 'franquicia', city: 'Alcorcón', active: true },
  { id: 'fr-mostoles', name: 'Natur Autoescuela Móstoles', type: 'franquicia', city: 'Móstoles', active: false },
];

// ---------- LISTADOS DE VALORES ----------
export const seedValueLists = [
  {
    id: 'categorias', name: 'Categorías de producto',
    values: [
      { id: 'matriculas', label: 'Matrículas', active: true },
      { id: 'packs', label: 'Packs', active: true },
      { id: 'bonos', label: 'Bonos de clases', active: true },
      { id: 'cursos', label: 'Cursos', active: true },
      { id: 'regalo', label: 'Tarjetas regalo', active: true },
    ],
  },
  {
    id: 'etiquetas', name: 'Etiquetas',
    values: [
      { id: 'popular', label: 'Más vendido', active: true },
      { id: 'nuevo', label: 'Nuevo', active: true },
      { id: 'oferta', label: 'Oferta', active: true },
      { id: 'todo-incluido', label: 'Todo incluido', active: true },
    ],
  },
  {
    id: 'estados-pedido', name: 'Estados de pedido',
    values: [
      { id: 'pendiente', label: 'Pendiente de pago', active: true },
      { id: 'pagado', label: 'Pagado', active: true },
      { id: 'completado', label: 'Completado', active: true },
      { id: 'cancelado', label: 'Cancelado', active: true },
    ],
  },
  {
    id: 'ciudades', name: 'Ciudades',
    values: [
      { id: 'valdemoro', label: 'Valdemoro', active: true },
      { id: 'mostoles', label: 'Móstoles', active: true },
      { id: 'alcorcon', label: 'Alcorcón', active: true },
      { id: 'pinto', label: 'Pinto', active: true },
      { id: 'parla', label: 'Parla', active: true },
      { id: 'getafe', label: 'Getafe', active: true },
      { id: 'fuenlabrada', label: 'Fuenlabrada', active: true },
    ],
  },
];

// ---------- CATÁLOGO ----------
export const seedProducts = [
  {
    id: 'p1', slug: 'matricula-permiso-b', name: 'Matrícula Permiso B',
    category: 'matriculas', tags: ['popular'],
    price: 90, comparePrice: 120, stock: 999, active: true,
    ownerId: 'matriz',
    image: 'https://images.unsplash.com/photo-1513258496099-48168024aec0?w=800&q=80',
    shortDescription: 'Tu primer paso hacia el carnet de conducir. Alta en autoescuela + gestión de expediente DGT.',
    description: 'La Matrícula del Permiso B incluye el alta como alumno en Natur Autoescuela, la apertura y gestión de tu expediente ante la DGT, y el acompañamiento de nuestro equipo durante todo el proceso. Es el primer paso para comenzar tu formación teórica y práctica.',
    features: ['Alta como alumno', 'Gestión expediente DGT', 'Asesoramiento personalizado', 'Sin permanencia'],
    seo: { metaTitle: 'Matrícula Permiso B | Natur Autoescuela', metaDescription: 'Matricúlate en el Permiso B con Natur Autoescuela. Gestión completa de tu expediente DGT y acompañamiento personalizado.' },
    faq: [
      { q: '¿Qué documentación necesito?', a: 'DNI o NIE en vigor y una fotografía tamaño carnet. Nosotros gestionamos el resto.' },
      { q: '¿Tiene caducidad la matrícula?', a: 'No, tu matrícula no caduca mientras tu expediente DGT esté activo.' },
    ],
  },
  {
    id: 'p2', slug: 'pack-matricula-teorico', name: 'Pack Matrícula + Teórico',
    category: 'packs', tags: ['todo-incluido', 'popular'],
    price: 150, comparePrice: 210, stock: 999, active: true,
    ownerId: 'matriz',
    image: 'https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?w=800&q=80',
    shortDescription: 'Matrícula + acceso ilimitado a la plataforma teórica online. 80% de aprobados a la primera.',
    description: 'El Pack Matrícula + Teórico combina el alta en la autoescuela con el acceso completo a nuestra plataforma de teoría online. Nuestro método de enseñanza esquematizado consigue que el 80% de nuestros alumnos aprueben el teórico a la primera.',
    features: ['Matrícula incluida', 'Plataforma online 24/7', 'Tests ilimitados DGT', 'Método esquematizado', 'Tutor personal'],
    seo: { metaTitle: 'Pack Matrícula + Teórico Online | Natur Autoescuela', metaDescription: 'Pack completo: matrícula y curso teórico online con el 80% de aprobados a la primera. Método esquematizado Natur.' },
    faq: [
      { q: '¿Cuánto dura el acceso a la plataforma?', a: 'El acceso es ilimitado hasta que apruebes tu examen teórico.' },
    ],
  },
  {
    id: 'p3', slug: 'bono-5-clases', name: 'Bono 5 Clases Prácticas',
    category: 'bonos', tags: [],
    price: 140, comparePrice: null, stock: 50, active: true,
    ownerId: 'fr-valdemoro',
    image: 'https://images.unsplash.com/photo-1553782097-130fef5d3e27?w=800&q=80',
    shortDescription: '5 clases prácticas de 45 minutos con profesor titulado y coche de la autoescuela.',
    description: 'Bono de 5 clases prácticas de conducción de 45 minutos cada una. Impartidas por profesores titulados con vehículos de doble mando. Ideal para tomar contacto con el coche o repasar antes del examen.',
    features: ['5 clases de 45 min', 'Profesor titulado', 'Coche de doble mando', 'Reserva flexible'],
    seo: { metaTitle: 'Bono 5 Clases Prácticas | Natur Autoescuela', metaDescription: 'Bono de 5 clases prácticas de conducción con profesores titulados. Reserva flexible y coches de doble mando.' },
    faq: [],
  },
  {
    id: 'p4', slug: 'bono-10-clases', name: 'Bono 10 Clases Prácticas',
    category: 'bonos', tags: ['popular', 'todo-incluido'],
    price: 265, comparePrice: 280, stock: 50, active: true,
    ownerId: 'fr-alcorcon',
    image: 'https://images.unsplash.com/photo-1516862523118-a3724eb136d7?w=800&q=80',
    shortDescription: 'El bono más vendido: 10 clases prácticas con descuento. Perfecto para preparar tu examen.',
    description: 'Nuestro bono más popular. 10 clases prácticas de 45 minutos con profesores titulados. Ahorra comprando en pack y prepara tu examen práctico con garantías.',
    features: ['10 clases de 45 min', 'Ahorro incluido', 'Profesor titulado', 'Coche de doble mando', 'Reserva flexible'],
    seo: { metaTitle: 'Bono 10 Clases Prácticas | Natur Autoescuela', metaDescription: 'Bono de 10 clases prácticas de conducción con descuento. El pack más vendido de Natur Autoescuela.' },
    faq: [],
  },
  {
    id: 'p5', slug: 'bono-20-clases', name: 'Bono 20 Clases Prácticas',
    category: 'bonos', tags: ['oferta'],
    price: 499, comparePrice: 560, stock: 30, active: true,
    ownerId: 'matriz',
    image: 'https://images.unsplash.com/photo-1524114051012-0a2aa8dae4e1?w=800&q=80',
    shortDescription: '20 clases prácticas al mejor precio por clase. Formación completa desde cero.',
    description: 'El bono de 20 clases ofrece el mejor precio por clase. Pensado para alumnos que empiezan desde cero y quieren una formación práctica completa hasta el examen.',
    features: ['20 clases de 45 min', 'Mejor precio por clase', 'Seguimiento de progreso', 'Profesor titulado'],
    seo: { metaTitle: 'Bono 20 Clases Prácticas | Natur Autoescuela', metaDescription: 'Bono de 20 clases prácticas al mejor precio por clase. Formación completa desde cero con Natur Autoescuela.' },
    faq: [],
  },
  {
    id: 'p6', slug: 'recuperacion-puntos', name: 'Curso Recuperación de Puntos',
    category: 'cursos', tags: ['nuevo'],
    price: 185, comparePrice: null, stock: 20, active: true,
    ownerId: 'matriz',
    image: 'https://images.unsplash.com/photo-1597762333765-cbcd63dd8acc?w=800&q=80',
    shortDescription: 'Curso de sensibilización y reeducación vial homologado por la DGT para recuperar puntos.',
    description: 'Curso de sensibilización y reeducación vial homologado por la DGT. Recupera hasta 6 puntos de tu permiso de conducir con nuestro curso oficial de 12 horas.',
    features: ['Homologado DGT', 'Recupera hasta 6 puntos', '12 horas de formación', 'Certificado oficial'],
    seo: { metaTitle: 'Curso Recuperación de Puntos DGT | Natur Autoescuela', metaDescription: 'Recupera hasta 6 puntos de tu carnet con nuestro curso homologado por la DGT. Plazas limitadas.' },
    faq: [
      { q: '¿Cuántos puntos puedo recuperar?', a: 'Hasta 6 puntos con el curso de sensibilización parcial, siempre que no hayas perdido todos los puntos.' },
    ],
  },
  {
    id: 'p7', slug: 'curso-cap', name: 'Curso CAP Formación Continua',
    category: 'cursos', tags: [],
    price: 320, comparePrice: null, stock: 15, active: true,
    ownerId: 'matriz',
    image: 'https://images.unsplash.com/photo-1616432043562-3671ea2e5242?w=800&q=80',
    shortDescription: 'Certificado de Aptitud Profesional para conductores profesionales. 35 horas de formación.',
    description: 'Curso CAP de formación continua de 35 horas para conductores profesionales de mercancías y viajeros. Renueva tu Certificado de Aptitud Profesional con nosotros.',
    features: ['35 horas de formación', 'Mercancías y viajeros', 'Certificado oficial', 'Horarios flexibles'],
    seo: { metaTitle: 'Curso CAP Formación Continua | Natur Autoescuela', metaDescription: 'Renueva tu CAP con nuestro curso de formación continua de 35 horas. Horarios flexibles para profesionales.' },
    faq: [],
  },
  {
    id: 'p8', slug: 'tarjeta-regalo', name: 'Tarjeta Regalo Natur',
    category: 'regalo', tags: ['nuevo'],
    price: 50, comparePrice: null, stock: 999, active: true,
    ownerId: 'matriz',
    image: 'https://images.unsplash.com/photo-1545785028-23ee5937cf69?w=800&q=80',
    shortDescription: 'Regala independencia. Tarjeta regalo canjeable por cualquier producto o servicio Natur.',
    description: 'La Tarjeta Regalo Natur es el regalo perfecto: canjeable por matrículas, bonos de clases o cursos. Se envía por email con un código único y no caduca.',
    features: ['Canjeable por todo el catálogo', 'Envío por email', 'Código único', 'No caduca'],
    seo: { metaTitle: 'Tarjeta Regalo | Natur Autoescuela', metaDescription: 'Regala el carnet de conducir con la Tarjeta Regalo Natur. Canjeable por cualquier curso o bono. No caduca.' },
    faq: [],
  },
];

// ---------- SEO LOCAL: CIUDADES ----------
export const seedCities = [
  {
    id: 'valdemoro', name: 'Valdemoro', slug: 'autoescuela-valdemoro', published: true,
    metaTitle: 'Autoescuela en Valdemoro | Natur Autoescuela',
    metaDescription: 'Sácate el carnet de conducir en Valdemoro con Natur Autoescuela. Teórico online y clases prácticas flexibles.',
    content: 'En Natur Autoescuela Valdemoro te ayudamos a conseguir tu Permiso B con nuestro método esquematizado: teórico 100% online y clases prácticas con profesores titulados en tu ciudad.',
    faq: [{ q: '¿Dónde se hacen las prácticas en Valdemoro?', a: 'Las clases prácticas se realizan en las zonas de examen habituales de la DGT para que llegues preparado.' }],
  },
  {
    id: 'mostoles', name: 'Móstoles', slug: 'autoescuela-mostoles', published: true,
    metaTitle: 'Autoescuela en Móstoles | Natur Autoescuela',
    metaDescription: 'Tu autoescuela en Móstoles: teórico online con 80% de aprobados a la primera y bonos de clases prácticas.',
    content: 'Natur Autoescuela llega a Móstoles con su método de enseñanza online. Fórmate a tu ritmo y practica con nuestros profesores en tu zona.',
    faq: [],
  },
  {
    id: 'alcorcon', name: 'Alcorcón', slug: 'autoescuela-alcorcon', published: true,
    metaTitle: 'Autoescuela en Alcorcón | Natur Autoescuela',
    metaDescription: 'Carnet de conducir en Alcorcón sin complicaciones. Teórico online y prácticas flexibles con Natur Autoescuela.',
    content: 'En Alcorcón, Natur Autoescuela te ofrece la forma más simple y eficiente de sacarte el carnet: todo online y clases prácticas cuando mejor te venga.',
    faq: [],
  },
  { id: 'pinto', name: 'Pinto', slug: 'autoescuela-pinto', published: false, metaTitle: 'Autoescuela en Pinto | Natur Autoescuela', metaDescription: '', content: 'Próximamente en Pinto.', faq: [] },
  { id: 'parla', name: 'Parla', slug: 'autoescuela-parla', published: false, metaTitle: 'Autoescuela en Parla | Natur Autoescuela', metaDescription: '', content: 'Próximamente en Parla.', faq: [] },
  { id: 'getafe', name: 'Getafe', slug: 'autoescuela-getafe', published: false, metaTitle: 'Autoescuela en Getafe | Natur Autoescuela', metaDescription: '', content: 'Próximamente en Getafe.', faq: [] },
  { id: 'fuenlabrada', name: 'Fuenlabrada', slug: 'autoescuela-fuenlabrada', published: false, metaTitle: 'Autoescuela en Fuenlabrada | Natur Autoescuela', metaDescription: '', content: 'Próximamente en Fuenlabrada.', faq: [] },
];

export const seedOrders = [
  {
    id: 'NAT-2025-0001', createdAt: '2025-07-28T10:24:00Z', status: 'pagado',
    customer: { name: 'María García', email: 'maria@example.com', phone: '612345678' },
    items: [{ productId: 'p2', name: 'Pack Matrícula + Teórico', qty: 1, price: 150 }],
    total: 150, franchiseId: 'matriz',
  },
  {
    id: 'NAT-2025-0002', createdAt: '2025-07-30T17:02:00Z', status: 'completado',
    customer: { name: 'Carlos Ruiz', email: 'carlos@example.com', phone: '699887766' },
    items: [{ productId: 'p4', name: 'Bono 10 Clases Prácticas', qty: 1, price: 265 }],
    total: 265, franchiseId: 'fr-alcorcon',
  },
];

// ---------- HERO SLIDES (contenido home) ----------
export const heroSlides = [
  {
    title: 'No te compliques con el Teórico',
    text: 'Tenemos un método de enseñanza esquematizado para que tengas un 80% de probabilidades de que lo saques a la primera.',
    cta: 'Me inscribo',
    image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=1200&q=80',
  },
  {
    title: 'TODO online sin complicaciones!',
    text: 'Inicia con un pack de INICIACIÓN A LA CONDUCCIÓN.',
    cta: 'Siguiente Paso',
    image: 'https://images.unsplash.com/photo-1471958680802-1345a694ba6d?w=1200&q=80',
  },
  {
    title: 'Todo Incluido',
    text: 'Pack 10 clases + Matrícula + Acceso plataforma Online.',
    cta: '¡Comprar ahora!',
    image: 'https://images.unsplash.com/photo-1549064233-945d7063292f?w=1200&q=80',
  },
];

// ============================================================
// STORE HELPERS (localStorage) - se sustituirán por API
// ============================================================
function load(key, seed) {
  try {
    const raw = localStorage.getItem(key);
    if (raw) return JSON.parse(raw);
  } catch (e) { /* noop */ }
  return seed;
}
function save(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

export const mockStore = {
  getProducts: () => load(LS_KEYS.products, seedProducts),
  saveProducts: (p) => save(LS_KEYS.products, p),
  getCities: () => load(LS_KEYS.cities, seedCities),
  saveCities: (c) => save(LS_KEYS.cities, c),
  getValueLists: () => load(LS_KEYS.valueLists, seedValueLists),
  saveValueLists: (v) => save(LS_KEYS.valueLists, v),
  getFranchises: () => load(LS_KEYS.franchises, seedFranchises),
  saveFranchises: (f) => save(LS_KEYS.franchises, f),
  getOrders: () => load(LS_KEYS.orders, seedOrders),
  saveOrders: (o) => save(LS_KEYS.orders, o),
  getCart: () => load(LS_KEYS.cart, []),
  saveCart: (c) => save(LS_KEYS.cart, c),
};

export const CONTACT = {
  phone: '+34 638 722 394',
  whatsapp: 'https://wa.me/34638722394?text=Hola%20quiero%20informaci%C3%B3n%20sobre%20el%20Permiso%20B',
  email: 'info@naturautoescuela.es',
};
